export default [
  {
    path: '/help/paper',
    name: 'help_paper',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/paper')
  },
  {
    path: '/help/bultra',
    name: 'help_bultra',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/bultra')
  },
  {
    path: '/help/uterus',
    name: 'help_uterus',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/uterus')
  },
  {
    path: '/help/symptom',
    name: 'help_symptom',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/symptom')
  },
  {
    path: '/help/amh',
    name: 'help_amh',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/amh')
  },
  {
    path: '/help/other_paper_more',
    name: 'help_other_paper_more',
    meta: {
      title: '了解更多'
    },
    component: () => import('views/help/other_paper_more')
  },
  {
    path: '/help/charts',
    name: 'help_charts',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/charts')
  },
  {
    path: '/help/bbt',
    name: 'help_bbt',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/bbt')
  },
  {
    path: '/help/cm',
    name: 'help_cm',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/cm')
  },
  {
    path: '/help/thermometer_3',
    name: 'help_thermometer_3',
    meta: {
      title: '使用帮助'
    },
    component: () => import('views/help/thermometer_3')
  },
  {
    path: '/help/thermometer_4',
    name: 'help_thermometer_4',
    meta: {
      title: '使用帮助'
    },
    component: () => import('views/help/thermometer_4')
  },
  {
    path: '/help/fetal_heart',
    name: 'help_fetal_heart',
    meta: {
      title: '常见问题与解答'
    },
    component: () => import('views/help/fetal_heart')
  },
  {
    path: '/help/q&a',
    name: 'help_q&a',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/q&a')
  },
  {
    path: '/help/calendar',
    name: 'help_calendar',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/calendar')
  },
  {
    path: '/help/menstruation',
    name: 'help_menstruation',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/menstruation')
  },
  {
    path: '/help/chart_legend',
    name: 'help_chart_legend',
    meta: {
      title: '示例说明'
    },
    component: () => import('views/help/chart_legend')
  },
  {
    path: '/help/hormone',
    name: 'help_hormone',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hormone')
  },
  {
    path: '/help/center',
    name: 'help_center',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/center')
  },
  {
    path: '/help/hcg_test',
    name: 'help_test',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_blood_test')
  },
  {
    path: '/help/sex_empty',
    name: 'sex_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/sex_empty')
  },
  {
    path: '/help/bu_empty',
    name: 'bu_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/bu_empty')
  },
  {
    path: '/help/lh_empty',
    name: 'lh_empty',
    meta: {
      title: '半定量排卵试纸'
    },
    component: () => import('views/help/lh_empty')
  },
  {
    path: '/help/lh_empty_card',
    name: 'lh_empty_card',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/lh_empty_card')
  },
  {
    path: '/help/lh_empty_other',
    name: 'lh_empty_other',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/lh_empty_other')
  },
  {
    path: '/help/lh_empty_jx_card',
    name: 'lh_empty_jx_card',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/lh_empty_jx_card')
  },
  {
    path: '/help/hcg_empty',
    name: 'hcg_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_empty')
  },
  {
    path: '/help/hcg_other_empty',
    name: 'hcg_other_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_other_empty')
  },
  {
    path: '/help/hcg_empty_semi',
    name: 'hcg_empty_semi',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_empty_semi')
  },
  {
    path: '/help/hcg_empty_pregnancy',
    name: 'hcg_empty_pregnancy',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_empty_pregnancy')
  },
  {
    path: '/help/hcg_other_empty_pregnancy',
    name: 'hcg_other_empty_pregnancy',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_other_empty_pregnancy')
  },
  {
    path: '/help/lh_box_empty',
    name: 'lh_box_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/lh_box_empty')
  },
  {
    path: '/help/hcg_box_empty',
    name: 'hcg_box_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_box_empty')
  },
  {
    path: '/help/box_video',
    name: 'box_video',
    meta: {
      title: '检测流程'
    },
    component: () => import('views/help/box_video'),
  },
  {
    path: '/help/hcg_box_chart_desc',
    name: 'hcg_box_chart_desc',
    meta: {
      title: 'HCG曲线说明'
    },
    component: () => import('views/help/hcg_box_chart_desc')
  },
  {
    path: '/help/hcg_box_week_info',
    name: 'hcg_box_week_info',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/hcg_box_week_info')
  },
  {
    path: '/help/hcg_box_value_info',
    name: 'hcg_box_value_info',
    meta: {
      title: '检测值没翻倍'
    },
    component: () => import('views/help/hcg_box_value_info')
  },
  {
    path: '/help/hcg_reference_standard',
    name: 'hcg_reference_standard',
    meta: {
      title: '同期HCG参考标准'
    },
    component: () => import('views/help/hcg_reference_standard')
  },
  {
    path: '/help/ordinary_thermometer_video',
    name: 'ordinary_thermometer_video',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/ordinary_thermometer_video')
  },
  {
    path: '/help/terms_and_privacy_policy',
    name: 'terms_and_privacy_policy',
    meta: {
      title: '隐私政策'
    },
    component: () => import('views/help/terms_and_privacy_policy')
  },
  {
    path: '/help/app_sdk_list_policy',
    name: 'app_sdk_list_policy',
    meta: {
      title: '第三方SDK目录'
    },
    component: () => import('views/help/app_sdk_list_policy')
  },
  {
    path: '/help/user_agreement',
    name: 'user_agreement',
    meta: {
      title: '用户协议'
    },
    component: () => import('views/help/user_agreement')
  },
  {
    path: '/help/blesdk_privacy_policy',
    name: 'blesdk_privacy_policy',
    meta: {
      title: '孕橙蓝牙SDK隐私政策'
    },
    component: () => import('views/help/blesdk_privacy_policy')
  },
  {
    path: '/help/papersdk_privacy_policy',
    name: 'papersdk_privacy_policy',
    meta: {
      title: '孕橙试纸SDK隐私政策'
    },
    component: () => import('views/help/papersdk_privacy_policy')
  },
  {
    path: '/help/consult_pregnancy_coach',
    name: 'consult_pregnancy_coach',
    meta: {
      title: '优孕师服务公告'
    },
    component: () => import('views/help/consult_pregnancy_coach')
  },
  {
    path: '/help/calendar_banner0',
    name: 'calendar_banner0',
    meta: {
      title: '备孕女性科学测排卵'
    },
    component: () => import('views/help/calendar_banner0')
  },
  {
    path: '/help/calendar_banner1',
    name: 'calendar_banner1',
    meta: {
      title: '多囊女性科学测排卵'
    },
    component: () => import('views/help/calendar_banner1')
  },
  {
    path: '/help/calendar_banner2',
    name: 'calendar_banner2',
    meta: {
      title: '高龄备孕不易，3招告别无效备孕，不要让你的卵子白白浪费掉'
    },
    component: () => import('views/help/calendar_banner2')
  },{
    path: '/help/calendar_banner3',
    name: 'calendar_banner3',
    meta: {
      title: '周期不规律，排卵试纸有大用，千万别忽视'
    },
    component: () => import('views/help/calendar_banner3')
  },{
    path: '/help/calendar_banner4',
    name: 'calendar_banner4',
    meta: {
      title: '经期不规律，周期还特别长，想要快速好孕怎么做？'
    },
    component: () => import('views/help/calendar_banner4')
  },{
    path: '/help/bultra_take_photo',
    name: 'bultra_take_photo',
    meta: {
      title: '拍摄前帮助引导'
    },
    component: () => import('views/help/bultra_take_photo')
  },
  {
    path: '/help/bultra_list_video',
    name: 'bultra_list_video',
    meta: {
      title: 'B超测排试纸引导'
    },
    component: () => import('views/help/bultra_list_video')
  },
  {
    path: '/help/bultra_list_video_detail',
    name: 'bultra_list_video_detail',
    meta: {
      title: 'B超测排试纸引导'
    },
    component: () => import('views/help/bultra_list_video_detail')
  },
  {
    path: '/help/paper_result_explain',
    name: 'paper_result_explain',
    meta: {
      title: '试纸结果如何解读?'
    },
    component: () => import('views/help/paper_result_explain')
  },
  {
    path: '/help/doctor_chart_legend',
    name: 'doctor_chart_legend',
    meta: {
      title: '图例说明'
    },
    component: () => import('views/help/doctor_chart_legend')
  },
  {
    path: '/help/print_preview',
    name: 'print_preview',
    meta: {
      title: '打印预览'
    },
    component: () => import('views/help/print_preview')
  },
  {
    path: '/help/lh_red',
    name: 'lh_red',
    meta: {
      title: '影响试纸褪红的几个因素'
    },
    component: () => import('views/help/lh_red')
  },
  {
    path: '/help/bbt_pregnancy',
    name: 'bbt_pregnancy',
    meta: {
      title: '基础体温'
    },
    component: () => import('views/help/bbt_pregnancy')
  },
  {
    path: '/help/baby_heart',
    name: 'baby_heart',
    meta: {
      title: '胎心胎芽'
    },
    component: () => import('views/help/baby_heart')
  },
  {
    path: '/help/yunnang',
    name: 'yunnang',
    meta: {
      title: '孕囊'
    },
    component: () => import('views/help/yunnang')
  },
  {
    path: '/help/fhrm',
    name: 'fhrm',
    meta: {
      title: '胎心监护'
    },
    component: () => import('views/help/fhrm')
  },
  {
    path: '/help/fhrm_video',
    name: 'fhrm_video',
    meta: {
      title: '胎心监护绑定'
    },
    component: () => import('views/help/fhrm_video')
  },
  {
    path: '/help/fhrm_video1',
    name: 'fhrm_video1',
    meta: {
      title: '胎心监护'
    },
    component: () => import('views/help/fhrm_video_1')
  },
  {
    path: '/help/hcg_blood_test_empty',
    name: 'hcg_blood_test_empty',
    meta: {
      title: '孕三项'
    },
    component: () => import('views/help/hcg_blood_test_empty')
  },
  {
    path: '/help/pr_video',
    name: 'pr_video',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/fhrm_video_1')
  },
  {
    path: '/help/lh_empty_other_lock',
    name: 'lh_empty_other_lock',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/lh_empty_other_lock')
  },
  {
    path: '/help/study_video',
    name: 'study_video',
    meta: {
      title: '快速好孕秘诀'
    },
    component: () => import('views/help/study_video')
  },
  {
    path: '/help/hcg_mul_card_chart',
    name: 'hcg_mul_card_chart',
    meta: {
      title: '半定量HCG胎儿发育曲线示例参考'
    },
    component: () => import('views/help/hcg_mul_card_chart')
  },
  {
    path: '/help/chart_empty',
    name: 'chart_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/chart_empty')
  },
  {
    path: '/help/sperm_empty',
    name: 'sperm_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/sperm_empty')
  },
  {
    path: '/help/jjjj_box',
    name: 'help_jjjj_box',
    meta: {
      title: '检测流程'
    },
    component: () => import('views/help/jjjj_box')
  },
  {
    path: '/help/sperm',
    name: 'sperm',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/sperm')
  },
  {
    path: '/help/fsh_empty',
    name: 'fsh_empty',
    meta: {
      title: '帮助'
    },
    component: () => import('views/help/fsh_empty')
  },
  {
    path: '/help/hcg_explain',
    name: 'hcg_explain',
    meta: {
      title: '半定量HCG检测卡测试须知'
    },
    component: () => import('views/help/hcg_explain')
  },
]